import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes, FaArrowRight } from "react-icons/fa";
import logoImage from '../images/digital.png';

function NavBar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 24);
        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname, location.hash]);

    const handleHomeClick = (event) => {
        if (location.pathname === "/" && !location.hash) {
            event.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
            setMenuOpen(false);
        }
    };

    const handleSectionClick = (id) => (event) => {
        if (location.pathname === "/") {
            event.preventDefault();
            navigate(`/#${id}`);
            const section = document.getElementById(id);
            if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
            setMenuOpen(false);
        }
    };

    const isHome = location.pathname === "/";

    return (
        <header className={`ciits-navbar-wrap ${isScrolled ? "is-scrolled" : ""}`}>
            <nav className="ciits-navbar" aria-label="Main navigation">
                <Link className="ciits-brand" to="/" onClick={handleHomeClick}>
                    <img className="ciits-brand-logo" src={logoImage} alt="CIITS logo" />
                    <span className="ciits-brand-copy">
                        CIITS
                        <small>Central India IT Services</small>
                    </span>
                </Link>

                <button
                    type="button"
                    className="ciits-menu-toggle"
                    onClick={() => setMenuOpen((open) => !open)}
                    aria-label={menuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={menuOpen}
                >
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>

                <div className={`ciits-nav-content ${menuOpen ? "is-open" : ""}`}>
                    <ul className="ciits-nav-links">
                        <li>
                            <Link
                                to="/"
                                className={`ciits-nav-link ${isHome && !location.hash ? "is-active" : ""}`}
                                onClick={handleHomeClick}
                            >
                                Home
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/about"
                                className={`ciits-nav-link ${location.pathname === "/about" ? "is-active" : ""}`}
                            >
                                About Us
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/#services"
                                className={`ciits-nav-link ${location.hash === "#services" ? "is-active" : ""}`}
                                onClick={handleSectionClick("services")}
                            >
                                Services
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/#products"
                                className={`ciits-nav-link ${location.hash === "#products" ? "is-active" : ""}`}
                                onClick={handleSectionClick("products")}
                            >
                                Our Products
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/#featured-work"
                                className={`ciits-nav-link ${location.hash === "#featured-work" ? "is-active" : ""}`}
                                onClick={handleSectionClick("featured-work")}
                            >
                                Our Work
                            </Link>
                        </li>
                    </ul>

                    <Link to="/contact" className="ciits-btn ciits-nav-cta">
                        Contact Us <FaArrowRight size={12} />
                    </Link>
                </div>
            </nav>
        </header>
    );
}

export default NavBar;
